
import Vue from "vue";
import {
  Agenda,
  DragAndDrop,
  ExcelExport,
  Print,
  Resize,
  ScheduleComponent,
  ViewsDirective,
  ViewDirective,
  ResourcesDirective,
  ResourceDirective,
  SchedulePlugin,
  TimelineMonth,
  TimelineViews
} from "@syncfusion/ej2-vue-schedule";
import SchedulerService from '@/services/scheduler.service'
import PartyService from '@/services/party.service'
import {eventBus} from "@/services/event-bus";
import Party from "@/models/party";
import AutomaticSchedulerEvent from "@/models/automaticSchedulerEvent";
import {Internationalization} from "@syncfusion/ej2-base";
import { scheduleData } from '@/components/datasource';
import { extend } from '@syncfusion/ej2-base';

const instance = new Internationalization();
const eventTemplateVue = Vue.component('eventTemplate', {
  template: `
    <div class='e-appointment-details' :style='{background: data.PrimaryColor}'>
      <div class="e-inner-wrap">
        <div class='e-subject' :style='{color:data.SecondaryColor}'>{{ data.Subject }}</div>
        <div class='e-time'>{{ this.getTimeString(data.StartTime) }}-{{ this.getTimeString(data.EndTime) }}</div>
      </div>
    </div>`,
  data() {
    return {
      data: {}
    };
  },
  methods: {
    getTimeString: function (value: any) {
      return instance.formatDate(value, {skeleton: 'hm'});
    }
  }
});
Vue.use(SchedulePlugin);

function toEmployee(p: Party) {
  return {id: p.id, text: `${p.name} ${p.surname}`};
}


export default Vue.extend({
  components: {
    'ejs-schedule': ScheduleComponent,
    'e-view': ViewDirective,
    'e-views': ViewsDirective,
    'e-resource': ResourceDirective,
    'e-resources': ResourcesDirective
  },
  data: function () {
    return {
      user: JSON.parse(String(localStorage.getItem('user'))),
      eventSettings: {
        dataSource: extend([], scheduleData, {}, true),
        enableIndicator: true,
        template: () => ({
          template: eventTemplateVue
        })
      },
      group: {
        enableCompactView: true,
        resources: ['Employees']
      },
      timeScale: {
        enable: true,
        interval: 60,
        slotCount: 2
      },
      readOnly: true,
      selectedDate: new Date(),
      orientation: 'Vertical',
      currentView: 'TimelineWeek',
      allowMultiple: false,
      workHours: {start: '08:00', end: '21:00'},
      employeeDataSource: [] as any[],
    }
  },
  computed: {
    schedulerInstance(): Vue & {
      exportToExcel: (args: any) => void,
      showSpinner: () => void,
      hideSpinner: () => void,
      getCurrentViewDates: () => any,
      print: () => void
    } {
      return this.$refs.ScheduleObj as Vue & {
        exportToExcel: (args: any) => void,
        showSpinner: () => void,
        hideSpinner: () => void,
        getCurrentViewDates: () => any,
        print: () => void
      };
    },
  },
  provide: {
    schedule: [Agenda, TimelineViews, TimelineMonth, Resize, DragAndDrop, ExcelExport, Print]
  },
  methods: {
    onActionBegin: function (args: any) {
      if (args.requestType === 'toolbarItemRendering') {
        const exportItem = {
          align: 'Right', showTextOn: 'Both', prefixIcon: 'e-icon-schedule-excel-export',
          text: 'Excel', cssClass: 'e-excel-export', click: this.onExportClick.bind(this)
        };
        const notifyItem = {
          align: 'Left', showTextOn: 'Both',
          text: 'SMS - Pacjenci', click: this.onNotifyClick.bind(this)
        };
        const notifyTherapistsItem = {
          align: 'Left', showTextOn: 'Both',
          text: 'SMS - Terapeuci', click: this.onNotifyTherapistsClick.bind(this)
        };
        // const generateItem = {
        //   align: 'Left', showTextOn: 'Both',
        //   text: 'Generuj', click: this.onGenerateClick.bind(this)
        // };
        // const regenerateItem = {
        //   align: 'Left', showTextOn: 'Both',
        //   text: 'ReGeneruj', click: this.onRegenerateClick.bind(this)
        // };
        // const savePlan = {
        //   align: 'Left', showTextOn: 'Both',
        //   text: 'Zapisz', click: this.onSaveClick.bind(this)
        // };
        const printPlan = {
          align: 'Left', showTextOn: 'Both',
          text: 'Drukuj', click: this.onPrintClick.bind(this)
        };
        args.items.push(exportItem);
        args.items.push(notifyItem);
        args.items.push(notifyTherapistsItem);

        // args.items.push(generateItem);
        // args.items.push(regenerateItem);
        // args.items.push(savePlan);
        args.items.push(printPlan);
      }
    },
    onGenerateClick: function () {
      this.schedulerInstance.showSpinner();
      const selectedDate = this.schedulerInstance.getCurrentViewDates()[1].toISOString().substr(0, 10);
      SchedulerService.generatePlanForWeek(selectedDate, this.user.office, false)
          .catch(e => eventBus.$emit('error', e.message));
    },
    onNotifyClick: function () {
      this.schedulerInstance.showSpinner();
      let selectedDate;
      if (this.schedulerInstance.getCurrentViewDates().length === 1) {
        selectedDate = this.schedulerInstance.getCurrentViewDates()[0]
      } else {
        selectedDate = new Date()
      }
      const offset = new Date().getTimezoneOffset()
      selectedDate = new Date(selectedDate.getTime() - (offset * 60 * 1000))
          .toISOString()
          .split('T')[0]
      SchedulerService.sendNotifications(selectedDate)
          .then(d => alert('Wysłano ' + d.data.sendNotifications + ' powiadomień'))
          .then(() => this.schedulerInstance.hideSpinner())
          .catch(e => eventBus.$emit('error', e.message));
    },
    onNotifyTherapistsClick: function () {
      this.schedulerInstance.showSpinner();
      let selectedDate;
      if (this.schedulerInstance.getCurrentViewDates().length === 1) {
        selectedDate = this.schedulerInstance.getCurrentViewDates()[0]
      } else {
        selectedDate = new Date()
      }
      const offset = new Date().getTimezoneOffset()
      selectedDate = new Date(selectedDate.getTime() - (offset * 60 * 1000))
          .toISOString()
          .split('T')[0]
      SchedulerService.sendNotificationsToTherapists(selectedDate)
          .then(d => alert('Wysłano ' + d.data.sendNotificationsToTherapists + ' powiadomień'))
          .then(() => this.schedulerInstance.hideSpinner())
          .catch(e => eventBus.$emit('error', e.message));
    },
    onRegenerateClick: function () {
      this.schedulerInstance.showSpinner();
      const selectedDate = this.schedulerInstance.getCurrentViewDates()[1].toISOString().substr(0, 10);
      SchedulerService.generatePlanForWeek(selectedDate, this.user.office, true)
          .catch(e => eventBus.$emit('error', e.message));
    },
    onSaveClick: function () {
      const selectedDate = this.schedulerInstance.getCurrentViewDates()[1].toISOString().substr(0, 10);
      SchedulerService.savePlanForWeek(selectedDate, this.user.office)
          .catch(e => eventBus.$emit('error', e.message));
    },
    onPrintClick: function () {
      this.schedulerInstance.print();
    },
    onExportClick: function () {
      let scheduleObj = this.schedulerInstance;
      let exportValues = {
        fields: ['Id', 'Subject', 'StartTime', 'EndTime', 'Location']
      };
      scheduleObj.exportToExcel(exportValues);
    },

  },
  mounted(): void {
    this.schedulerInstance.showSpinner();
    const s = this.schedulerInstance;
    // const es = this.eventSettings;
    // SchedulerService.subscribeForAutomaticPlanning(this.user.office).subscribe({
    //   next(data) {
    //     if (data.data) {
    //       const arr = data.data.subscribeForAutomaticPlanning.map((it: any) => new AutomaticSchedulerEvent(it));
    //       const htmlElement = document!.getElementById('Schedule')! as any;
    //       htmlElement.ej2_instances[0].eventSettings.dataSource = arr;
    //     }
    //     s.hideSpinner();
    //   },
    //   error(error) {
    //     // eslint-disable-next-line no-console
    //     console.error(error);
    //     s.hideSpinner()
    //   },
    // });
    PartyService.allTherapist().then(r => r.map(toEmployee)).then(r => this.employeeDataSource = r)
        .then(() => s.hideSpinner())
        .catch(e => eventBus.$emit('error', e))
    SchedulerService.eventsForOffice(this.user.office)
        .then(r => r.map((it: any) => new AutomaticSchedulerEvent(it)))
        .then(r => (document!.getElementById('Schedule')! as any).ej2_instances[0].eventSettings.dataSource = r)
        .then(() => s.hideSpinner())
        .catch(e => eventBus.$emit('error', e))

  }
});
